// extracted by mini-css-extract-plugin
export default {"container":"FilterDifficultySubcategories_container__5-tnC"};